<script>
	import {addBacthData} from "../../../../../api/Batch";

	import {GeneralData, MicrobiologyData, NutritionalData}  from "../../../../../stores.js";

	import {onMount} from "svelte";


	let generalData = null;

	let microbiologyInputs = null;

	let nutritionalInputs = null;

	let company = null;
	let companyProducts = null;

	onMount(() => {

		company = localStorage.getItem('company');
		company = JSON.parse(company);

		companyProducts = company.Products;

		generalData = [];
		microbiologyInputs = [];
		nutritionalInputs = [];

		for(let i = 0 ; i < GeneralData.length ; i++ ){

			var auxArray = [];
			for (const [key, value] of Object.entries(GeneralData[i])) {

				if(key == 'Product'){

					if(GeneralData[i].Product.options.length == 0){
						for(let index = 0 ; index < companyProducts.length ; index++){

							var auxObj = {};

							auxObj.value = companyProducts[index].name;

							GeneralData[i].Product.options.push(auxObj);	

							
						}	
					}
				}

				if(batchItemTypes[key] == 'select'){
					batchItem[key] = 'Select';
				}

  				auxArray.push(value);
			}

			generalData.push(auxArray);

		}

		generalData = generalData;


		for(let i = 0 ; i < MicrobiologyData.length ; i++ ){

			var auxArray = [];
			for (const [key, value] of Object.entries(MicrobiologyData[i])) {

				
				if(value.type == 'select'){
					microbiology[value.key] = 'Select';
				}
  				microbiologyInputs.push(value)
			}
		}

		microbiologyInputs = microbiologyInputs;
		

		for(let i = 0 ; i < NutritionalData.length ; i++ ){

			var auxArray = [];
			for (const [key, value] of Object.entries(NutritionalData[i])) {
  				// auxArray.push(value);
  				nutritionalInputs.push(value);
			}

			// nutritionalInputs.push(auxArray);

		}

		nutritionalInputs = nutritionalInputs;
	});

	var date = new Date();

	/*
		formState

		0 - General Info
		1-  Data Type
		2 - Microbiology Info
		3 - Nutritional Info

		default state: 0
	*/

	let formState = 0;

	/*
		prevents from changing the formState variable before all fields are filled
	*/
	let dataSaved = false;

	export let newBatchOpen = true;


	// var numberOfSamples = null;
	var sampleID = 1;

	let batchItem = {
		Product: null,
		BatchID: null,
		BatchSize: null,
		Trial:null,
		ProductionDate:null,
		NumberOfSamples: null,
	}


	/* 
		dataType - mean values or individual values per sample

		Values : Mean or Individual
	*/

	let dataType = 'Select';
	// let dataType = 'Mean'

	let batchItemTypes = {

		Product: 'select',
		BatchID: 'string',
		BatchSize: 'number',
		Trial:'select',
		ProductionDate:'date',
		NumberOfSamples: 'number'
	}
	let microbiologyItemTypes = Object.keys(MicrobiologyData[0]).reduce((o, key) => ({ ...o, [key]: "number"}), {});


	let finalBatchItem = {
		Company: null,
		InsertionDate:null,
	}

	let Samples = [];
	let microbiology = Object.keys(MicrobiologyData[0]).reduce((o, key) => ({ ...o, [key]: null}), {});
	let nutritional = Object.keys(NutritionalData[0]).reduce((o, key) => ({ ...o, [key]: null}), {});

	/*
		Reactive block to add or remove keys from microbiology and nutritional objects

		If dataType == Mean:

			 - microbiology obj : add Min and Max keys for each existing key.
			 - nutritional obj : add Standard Deviation for each existing key.
		If dataTyepe == Individual
			- microbiology obj : remove Min and Max for each existing key.
			- nutritional obj :  remove Standard Deviation for each existing key.
	*/

	/*
	 runOnce - var used to prevent reactive code to perform same action more than once
	*/
	let runOnce = false;
	$:{
		if((dataType != null || dataType != undefined || dataType != 'Select') && microbiologyInputs != null){

			if(dataType == 'Mean' && !runOnce){

						
						if(microbiology.hasOwnProperty('LAB_Min')){
							//do nothing
						}
						else{

							for (const [key, value] of Object.entries(microbiology)){

								
								if(key == 'Salmonella' || key == 'ListeriaAbs'){

								}
								else{
									console.log(key);
									let keyMin = key + '_Min';
									let keyMax = key + '_Max';
									microbiology[keyMin] = null;
									microbiology[keyMax] = null;
								}

							}

							// console.log(microbiology);

							for (const [key, value] of Object.entries(nutritional)){
								let keyStd = key + '_Std';
								nutritional[keyStd] = null;
							}
						}

						if(batchItem.NumberOfSamples > 1){

							microbiologyInputs[6].options = [];
							microbiologyInputs[7].options = [];

							for(let i = 0; i <= batchItem.NumberOfSamples ; i++ ){
								let option = {
									value: i
								}

								microbiologyInputs[6].options.push(option);		
								microbiologyInputs[7].options.push(option);
							}	
						}
			}
			else if(dataType == 'Individual' && !runOnce){

					//check if the objects have the Min, Max and Std keys
					if(microbiology.hasOwnProperty('LAB_Min')){
						for (const [key, value] of Object.entries(microbiology)){

							if(key != 'Salmonella' || key != 'ListeriaAbs'){
								let keyMin = key + '_Min';
								let keyMax = key + '_Max';
								delete microbiology[keyMin]; 
								delete microbiology[keyMax];
							} 


						}
						for (const [key, value] of Object.entries(nutritional)){
							let keyStd = key + '_Std';
							delete nutritional[keyStd];
						}
					}

					if(microbiologyInputs[6].options.length > 2){

						microbiologyInputs[6].options = [];
						microbiologyInputs[7].options = [];

						for(let i = 0; i < 2; i++){
							let option = {
								value: i
							}

							microbiologyInputs[6].options.push(option);		
							microbiologyInputs[7].options.push(option);
						}
					}
			} 
		}
	}

	// updates the state of the Data Saved Variable
	function updateDataSaved(formState){

		var res = null;

		const indexBatch = Samples.findIndex(item => item.SampleID == sampleID );


		// microbiology data
		if(formState == 2 && dataType == 'Individual'){


			if(indexBatch == -1){
				
				for (const [key, value] of Object.entries(microbiology)){

					if(microbiologyItemTypes[key] == 'select'){
						microbiology[key] = 'Select';	
					}
					else{
						microbiology[key] = null;	
					}
					
				}

				res = false;
			}
			else{

				// microbiology = Samples[sampleID-1].Microbiology;

				Object.keys(microbiology).find(key => {

					if(Samples[sampleID-1].Microbiology[key]){
						microbiology[key] =  Samples[sampleID-1].Microbiology[key];
					}
					else{
						if(microbiologyItemTypes[key] == 'select'){
							microbiology[key] = 'Select';
						}
						else{
							microbiology[key] = null;	
						}
					}
					
				});

				res = true;
			}
		}
		// nutritional data
		else if(formState == 3 && dataType == 'Individual'){

			// console.log(Samples[sampleID-1]);
			if(Samples[sampleID-1].Nutritional){
				
				res = true;
				nutritional = Samples[sampleID-1].Nutritional;
			}
			else{
				
				for (const [key, value] of Object.entries(nutritional)){

					nutritional[key] = null;
				}
				res = false;
			}
			
		}
		else if(formState == 2 && dataType == 'Mean'){

			res = false;
			for (const [key, value] of Object.entries(microbiology)){

					if(value == null || value == 'Select'){

					}
					else{
						res = true;
					}
			}
		}
		else if(formState == 3 && dataType == 'Mean'){
			res = false;
			for (const [key, value] of Object.entries(nutritional)){

					if(value == null){

					}
					else{
						res = true;
					}
			}

		}
		// general data and Data type
		else{
			res = true;
		}




		return res;
	}

	//Handles the form state logic
	function changeFormState(e){

		let id = e.target.id;

		// Next on General Data
		if(id == 'Next' && formState == 0 ){

			formState++;
			dataSaved = updateDataSaved(formState);

		} 

		//Next on Data Type 

		else if(id == 'Next' && formState == 1){

			formState ++;
			dataSaved = updateDataSaved(formState);

		}
		else if(id == 'Next' && formState == 2 && dataType == 'Mean'){
			formState++;
			dataSaved = updateDataSaved(formState);

		}
		// Next on microbiology data
		else if(id == 'Next' && formState == 2 &&  dataType == 'Individual'){

			if(sampleID < batchItem.NumberOfSamples){

				sampleID++;
				dataSaved = updateDataSaved(formState);

			}
			else{

				//Goes to nutritional sample values
				formState++;
				sampleID = 1;
				dataSaved = updateDataSaved(formState);
				
			}
		}

		else if(id == 'Next' && formState == 3 && dataType == 'Mean'){
			formState++;
			dataSaved = updateDataSaved(formState);
		}
		// Next on nutritional data
		else if(id == 'Next' && formState == 3 && dataType == 'Individual'){

			if(sampleID < batchItem.NumberOfSamples){

				sampleID++;
				dataSaved = updateDataSaved(formState);

			}
			else{
				
			}
		}

		// Back on data type
		else if(id == 'Back'  && formState == 1){
			formState--;
			dataSaved = updateDataSaved(formState);			
		}
		else if(id == 'Back' && formState == 2 && dataType == 'Mean'){
			formState--;
			dataSaved = updateDataSaved(formState);
		}
		// Back on microbiology data
		else if(id == 'Back' && formState == 2 && dataType == 'Individual'){

			if(sampleID > 1){

				//Goes back on microbiology samples
				sampleID--;
				dataSaved = updateDataSaved(formState);
			}
			else{
					
				//Returns to Data Type
				formState--;
				sampleID = 1;
				dataSaved = updateDataSaved(formState);

			}
		}
		else if(id == 'Back' && formState == 3 && dataType == 'Mean'){
			formState--;
			dataSaved = updateDataSaved(formState);
		}
		// Back on nutritional data
		else if(id == 'Back' && formState == 3 && dataType == 'Individual'){

			if(sampleID > 1){

				//Goes back on nutritional samples
				sampleID--;
				dataSaved = updateDataSaved(formState);

			}
			else{

				//Returns to last Value of Microbiology Data
				formState--;
				sampleID = batchItem.NumberOfSamples;
				dataSaved = updateDataSaved(formState);

			}
		}
	}

	//Form Submition to DB
	async function submitForm(){
		
		var user = localStorage.getItem('user');

		user =  JSON.parse(user);

		finalBatchItem.Company = user.company;
		finalBatchItem.DataType = dataType;
		finalBatchItem.InsertionDate = date.toLocaleDateString();
		finalBatchItem.Samples = [];
		finalBatchItem.Samples = Samples;
		
		var userData = {
			data: [],
		}

		userData.data.push(finalBatchItem);

		var res = await addBacthData(userData);

		if(res.status == 'valid'){
			newBatchOpen = false;
			alert('New batch added with success to the database!');
		}
		else if(res.status == 'error'){

			if(res.code == 'BAE'){
				alert(res.error);
			}
			else{
				alert('There was an error submiting the data to the data base! Try again!');	
			}
			
		}
	}

	function saveData(){

		//General Info
		if(formState == 0){

			var allInputsValid = 0;
			for (const [key, value] of Object.entries(batchItem)) {
			  	
			  	if(value == null || value == '' || value == 'Select'){
			  		
			  		//alert user - field must be filled
			  		var el = document.getElementById(key);
			  		el.style.border = "1px solid red";
			  		el.style.setProperty("--c", "red");

			  	}
			  	else{


			  		if(batchItemTypes[key] == 'string'){

			  			if(typeof value == 'string'){
			  				allInputsValid++;
			  				var el = document.getElementById(key);
					  		el.style.border = "1px solid white";
			  				el.style.setProperty("--c", "black");
			  			}
			  			else{
			  				var el = document.getElementById(key);
					  		el.style.border = "1px solid red";
			  				el.placeholder = 'Required value of type string';
			  				el.style.setProperty("--c", "red");
			  			}
			  		}
			  		else if(batchItemTypes[key] == 'number'){

			  			if(!isNaN(value)){
			  				allInputsValid++;
			  				var el = document.getElementById(key);
					  		el.style.border = "1px solid white";
			  				el.style.setProperty("--c", "black");	
			  			}
			  			else{
			  				var el = document.getElementById(key);
					  		el.style.border = "1px solid red";
			  				el.placeholder = 'Required value of type number';
			  				el.style.setProperty("--c", "red");
			  			}

			  		}
			  		// select or date types
			  		else{
			  			var el = document.getElementById(key);
					  	el.style.border = "1px solid white";
			  			allInputsValid++;
			  			el.style.setProperty("--c", "black");
			  		}
					
			  		
			  	}
			}

			if(allInputsValid == Object.keys(batchItem).length){
				dataSaved = true;
				
				finalBatchItem = {...finalBatchItem, ...batchItem};
			}
		}
		// Data Type
		else if(formState == 1){


			if(dataType == null || dataType == 'Select'){
				var el = document.getElementById('dataType');
			  		el.style.border = "1px solid red";
			  		el.style.setProperty("--c", "red");
			  		el.placeholder = 'enter a value';
			}
			else{
				dataSaved = true;	
				var el = document.getElementById('dataType');
			  	el.style.border = "1px solid white";
			  	el.style.setProperty("--c", "black");
	  			allInputsValid++;
			}	
			
		}
		//Microbiology Info - only Mesophiles required
		else if(formState == 2){

			var allInputsValid = 0;
			var microbiologyAux = {};

			if(dataType == 'Mean'){

				for (const [key, value] of Object.entries(microbiology)) {
			  		

					console.log(key);
				  	if(key == 'Mesophiles' && (value == null || value == '') ){
				  		
				  		//alert user - field must be filled
				  		var el = document.getElementById(key);
				  		el.style.setProperty("--c", "red");
				  		

				  	}
				  	else{

				  		if(value != 'Select'){
				  			if(!isNaN(value) || value == ''){
				  				if(value != null && value != ''){
				  					microbiologyAux[key] = value;	
				  				}
					  			allInputsValid++;
				  				var el = document.getElementById(key);
						  		el.placeholder = 'Enter a value';
						  		el.style.setProperty("--c", "black");

				  			}
				  			else{
				  				var el = document.getElementById(key);
						  		el.value = null;
						  		el.placeholder = 'Value should be a number';
						  		el.style.setProperty("--c", "red");
				  			}
				  		}
				  		else{
				  			allInputsValid++;

				  		}
				  		

				  	}
				}

				if(allInputsValid == Object.keys(microbiology).length){

					var sample = {};
					sample.Microbiology = {};
					sample.Microbiology = microbiologyAux;
					Samples.push(sample);

					dataSaved = true;
					
				}


				
			}
			else if(dataType == 'Individual'){
				for (const [key, value] of Object.entries(microbiology)) {
			  		

				  	if(key == 'Mesophiles' && (value == null || value == '') ){
				  		
				  		//alert user - field must be filled
				  		var el = document.getElementById(key);
				  		el.style.setProperty("--c", "red");

				  	}
				  	else{

				  			if(value != 'Select'){



						  		if(!isNaN(value) || value == ''){
						  			if(value != null && value != ''){
						  				microbiologyAux[key] = value;	
						  			}
					  				
						  			allInputsValid++;
					  				var el = document.getElementById(key);
							  		el.placeholder = 'Enter a value';
								  	el.style.setProperty("--c", "black");	
					  			}
					  			else{
					  				var el = document.getElementById(key);
							  		el.value = null;
								  	el.placeholder = 'Value should be a number';
								  	el.style.setProperty("--c", "red");
					  			}
					  		}
					  		else{
					  			allInputsValid++;
					  		}
				  	}
				}

				if(allInputsValid == Object.keys(microbiology).length){

					var sample = {};
					sample.Microbiology = {};
					sample.SampleID = sampleID;
					sample.Microbiology = microbiologyAux;

					if(Samples[sampleID-1]){

						
						if(Samples[sampleID-1].Nutritional){

							sample.Nutritional = Samples[sampleID-1].Nutritional; 
							
						}


						Samples[sampleID-1] = sample;
					}
					else{
						
						Samples.push(sample);
						
					}
					dataSaved = true;
					
				}
			}
		}
		//Nutritional Info -- all inputs not required
		else if(formState == 3){

			var allInputsValid = 0;
			var nutritionalAux = {}


			if(dataType == 'Mean'){

				for (const [key, value] of Object.entries(nutritional)) {
			  		
					if(value == null || value == ''){
				  		allInputsValid++;
				  	}
				  	else{
				  		if(!isNaN(value) || value == ''){
				  			if(value != null && value != ''){
				  				nutritionalAux[key] = value;	
				  			}
				  			allInputsValid++;
			  				var el = document.getElementById(key);
					  		el.placeholder = 'Enter a value';
						  	el.style.setProperty("--c", "black");

						}
			  			else{
			  				var el = document.getElementById(key);
					  		el.value = null;
						  	el.placeholder = 'Value should be a number';
						  	el.style.setProperty("--c", "red");
			  			}
				  	}

				} 	

				if(allInputsValid == Object.keys(nutritional).length){

					
					
					Samples[0].Nutritional = {};
					Samples[0].Nutritional = nutritionalAux; 
					dataSaved = true;
					
				}

			}
			else if(dataType == 'Individual'){
				for (const [key, value] of Object.entries(nutritional)) {
			  	
				  	// nutritionalAux[key] = value;
				  	// allInputsValid++;
				  	if(value == null || value == ''){
				  		allInputsValid++;
				  	}
				  	else{
				  		if(!isNaN(value) || value == ''){
				  			if(value != null && value != ''){
				  				nutritionalAux[key] = value;	
				  			}
			  				
				  			allInputsValid++;
			  				var el = document.getElementById(key);
					  		el.placeholder = 'Enter a value';
						  	el.style.setProperty("--c", "black");
			  			}
			  			else{
			  				var el = document.getElementById(key);
						  	el.style.setProperty("--c", "red");
					  		el.placeholder = 'Value should be a number';
			  			}
				  	}
				  	
				  	
				}

				if(allInputsValid == Object.keys(nutritional).length){
					
					Samples[sampleID-1].Nutritional = {};
					Samples[sampleID-1].Nutritional = nutritionalAux; 
					dataSaved = true;
					
				}
			}

		}
		else{
			//error
		}

	}

	function dataChanged(){

		if(dataSaved == false){

		}
		else{
			dataSaved = false;
		}
	}


	var microIndividualTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Value"
		},
		{
			title: "Units"
		}
	];

	var nutriIndividualTableHeader = [
		{
			title: "Property"
		},
		{
			title: "Value"
		},
		{
			title: "Units"
		}
	];

	var microTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Mean"
		},
		{
			title: "Min"
		},
		{
			title: "Max"
		},
		{
			title: "Units"
		}
	];


	var microDetectionTableHeader = [
		{
			title: "Bacteria"
		},
		{
			title: "Positive Samples"
		}
	];

	var nutriTableHeader = [
		{
			title: "Property"
		},
		{
			title: "Mean"
		},
		{
			title: "Standard deviation"
		},
		{
			title: "Units"
		}
	];

</script>



<div class="newBatchFormContainer">
		
		<div class="titleContainer">

			{#if formState == 0} <!--Batch General Info -->
				<div class="titleItem titleItemSelected textOrange">Batch General Info</div>
				<div class="titleItem">Data Type</div>
				<div class="titleItem">Microbiology Info</div>
				<div class="titleItem">Nutritional Info</div>
			{:else if formState == 1} <!-- Data Type -->
				<div class="titleItem">Batch General Info</div>
				<div class="titleItem titleItemSelected textOrange">Data Type</div>
				<div class="titleItem">Microbiology Info</div>
				<div class="titleItem">Nutritional Info</div>
			{:else if formState == 2} <!--Microbiology Info -->
				<div class="titleItem">Batch General Info</div>
				<div class="titleItem">Data Type</div>
				{#if dataType == 'Mean'}
					<div class="titleItem titleItemSelected textOrange">Microbiology Info</div>
				{:else if dataType == 'Individual'}
					<div class="titleItem titleItemSelected textOrange">{sampleID} Microbiology Info</div>
				{:else}
				{/if}
				
				<div class="titleItem">Nutritional Info</div>
			{:else if formState == 3}<!--Nutritional Info-->
				<div class="titleItem">Batch General Info</div>
				<div class="titleItem">Data Type</div>
				<div class="titleItem">Microbiology Info</div>
				{#if dataType == 'Mean'}
					<div class="titleItem titleItemSelected textOrange">Nutritional Info</div>
				{:else if dataType == 'Individual'}
					<div class="titleItem titleItemSelected textOrange">{sampleID} Nutritional Info</div>
				{:else}
				{/if}
				
			{:else}
				<div>error</div>
			{/if}
		</div>

		<div class="formColumnsContainer">

			{#if formState == 0} <!--Batch General Info -->

				{#if generalData != null}
					{#each generalData as col,index}
						<div class="formColumn generalInfo">
								{#each col as input}

									<label class="formLabel" for={input.key}>{input.label} </label>
									{#if input.type == 'string' || input.type == 'number' }
										
										<input on:change={() => dataChanged()} bind:value={batchItem[input.key]} class="formInput" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>

									{:else if input.type == 'select'}

										<select on:change={() => dataChanged()} bind:value={batchItem[input.key]} class="formInput formSelect" id={input.key} name={input.label} placeholder={input.placeholder}>

											<option class="tableInputSelectOption"  selected value="Select">Select</option>
											{#each input.options as option}
												<option class="formInputOption" value={option.value}>{option.value}</option>
											{/each}
										</select>
									{:else if input.type == 'date' }
										<input on:change={() => dataChanged()} bind:value={batchItem[input.key]} class="formInput" type="date" name={input.label} id={input.key} placeholder={input.placeholder}>

									{/if}
								{/each}
						</div>
					{/each}
				{/if}

			{:else if formState == 1} <!-- Data Type -->


				<div class="formColumn dataType">

					<label class="formLabel" for="dataType">Data Type</label>

					<select on:change={() => dataChanged()} bind:value={dataType} class="formInput formSelect" id="dataType" name="dataType">
							
							<option class="tableInputSelectOption"  selected value="Select">Select</option>
							<option class="formInputOption" value="Mean">Mean values</option>
							<option class="formInputOption" value="Individual">Individual values per sample</option>
						
					</select>
					
				</div>

				<div class="formColumn dataType">
					
				</div>

			{:else if formState == 2} <!--Microbiology Info -->

				{#if dataType == 'Mean'}



					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each microTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>
						<div class="scrollableRows">
						{#if microbiologyInputs!= null}
							{#each microbiologyInputs as input, index}
									{#if !input.options}
										<div class="meanTableRow">
											<div class="meanTableRowItem ">{input.key}</div>
											{#if input.type == 'text'}
												<input on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{:else if input.type == 'select'}
												<select on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

													<option class="tableInputSelectOption"  selected value="Select">Select</option>
													{#each input.options as option}
														<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
													{/each}
												</select>
											{/if}

											<input on:change={() => dataChanged()} bind:value={microbiology[input.keyMin]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyMin} placeholder={input.placeholder}>
											<input on:change={() => dataChanged()} bind:value={microbiology[input.keyMax]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyMax} placeholder={input.placeholder}>

											<div class="meanTableRowItem">{input.units}</div>

										</div>

									{/if}
							{/each}
						{/if}
						</div>
					</div>

					<!-- detection table -->
					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each microDetectionTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>

						{#if microbiologyInputs!= null}
							<!-- {#each microbiologyInputs as col, index} -->
							{#each microbiologyInputs as input, index}
								<!-- {#each col as input} -->
									{#if input.options}
										<div class="meanTableRow">
											<div class="meanTableRowItem ">{input.key}</div>
											{#if input.type == 'text'}
												<input on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{:else if input.type == 'select'}
												<select on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

													<option class="tableInputSelectOption"  selected value="Select">Select</option>
													{#each input.options as option}
														<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
													{/each}
												</select>
											{/if}

											<!-- <input on:change={() => dataChanged()} bind:value={microbiology[input.keyMin]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyMin} placeholder={input.placeholder}>
											<input on:change={() => dataChanged()} bind:value={microbiology[input.keyMax]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyMax} placeholder={input.placeholder}>

											<div class="meanTableRowItem">{input.units}</div> -->

										</div>

									{/if}
								<!-- {/each} -->
							{/each}
						{/if}


					</div>

					
				{:else if dataType == 'Individual'}

					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each microIndividualTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>
						<div class="scrollableRows">
							{#if microbiologyInputs!= null}
								{#each microbiologyInputs as input, index}
										{#if !input.options}
											<div class="meanTableRow">
												<div class="meanTableRowItem ">{input.key}</div>
												{#if input.type == 'text'}
													<input on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
												{:else if input.type == 'select'}
													<select on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

														<option class="tableInputSelectOption"  selected value="Select">Select</option>
														{#each input.options as option}
															<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
														{/each}
													</select>
												{/if}

												<div class="meanTableRowItem">{input.units}</div>

											</div>

										{/if}
								{/each}
							{/if}
						</div>


					</div>

					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each microDetectionTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>
							{#if microbiologyInputs!= null}
								<!-- {#each microbiologyInputs as col, index} -->
								{#each microbiologyInputs as input, index}
									<!-- {#each col as input} -->
										{#if input.options}
											<div class="meanTableRow">
												<div class="meanTableRowItem ">{input.key}</div>
												{#if input.type == 'text'}
													<input on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
												{:else if input.type == 'select'}
													<select on:change={() => dataChanged()} bind:value={microbiology[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

														<option class="tableInputSelectOption"  selected value="Select">Select</option>
														{#each input.options as option}
															<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
														{/each}
													</select>
												{/if}

											</div>

										{/if}
								{/each}
							{/if}
					</div>

				{/if}

			{:else if formState == 3}<!--Nutritional Info-->

				{#if dataType == 'Mean'}

					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each nutriTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>

						<div class="scrollableRows">
						{#if nutritionalInputs!= null}
							{#each nutritionalInputs as input, index}
									{#if input.type != 'dummy'}
										<div class="meanTableRow">
											<div class="meanTableRowItem ">{input.key}</div>
											{#if input.type == 'text'}
												<input on:change={() => dataChanged()} bind:value={nutritional[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
											{:else if input.type == 'select'}
												<select on:change={() => dataChanged()} bind:value={nutritional[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

													<option class="tableInputSelectOption"  selected value="Select">Select</option>
													{#each input.options as option}
														<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
													{/each}
												</select>
											{/if}

											<input on:change={() => dataChanged()} bind:value={nutritional[input.keyStd]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.keyStd} placeholder={input.placeholder}>

											<div class="meanTableRowItem">{input.units}</div>

										</div>

									{/if}
							{/each}
						{/if}
					</div>


					</div>

				{:else if dataType == 'Individual'}

					<div class="meanTableContainer">
						
						<div class="meanTableRow">
							{#each nutriIndividualTableHeader as header,index}
								<div class="meanTableRowItem">
									{header.title}
								</div>
							{/each}
						</div>
						<div class="scrollableRows">
							{#if nutritionalInputs!= null}
								{#each nutritionalInputs as input, index}
										{#if input.type != 'dummy'}
											<div class="meanTableRow">
												<div class="meanTableRowItem">{input.key}</div>
												{#if input.type == 'text'}
													<input on:change={() => dataChanged()} bind:value={nutritional[input.key]} class="meanTableRowItem tableInputText" type="text" name={input.label} id={input.key} placeholder={input.placeholder}>
												{:else if input.type == 'select'}
													<select on:change={() => dataChanged()} bind:value={nutritional[input.key]} class="meanTableRowItem tableInputSelect" id={input.key} name={input.label}>

														<option class="tableInputSelectOption"  selected value="Select">Select</option>
														{#each input.options as option}
															<option class="tableInputSelectOption" value={option.value}>{option.value}</option>
														{/each}
													</select>
												{/if}

												<div class="meanTableRowItem">{input.units}</div>

											</div>

										{/if}
								{/each}
							{/if}
						</div>
					</div>
				
				{/if}	
			{/if}
		</div>


		<div class="formSubmitBtnContainer">

			{#if formState == 0}  <!--Batch General Info -->
				<div class="formSubmitBtnInactive">
					Back
				</div>
				
				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={(e)=> changeFormState(e)}>
						Next
					</div>	
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next" >
					Next
					</div>	
				{/if}
			
			{:else if formState == 1} <!-- Data Type -->

				<div class="formSubmitBtn" id="Back" on:click={(e)=> changeFormState(e)}>
					Back
				</div>
				
				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={(e)=> changeFormState(e)}>
						Next
					</div>	
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next" >
					Next
					</div>	
				{/if}

			{:else if formState == 2} <!--Microbiology Info-->
				<div class="formSubmitBtn" id="Back" on:click={(e)=> changeFormState(e)}>
					Back
				</div>
				
				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={(e)=> changeFormState(e)}>
						Next
					</div>	
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next" >
						Next
					</div>	
				{/if}
				
			{:else if (formState == 3 && sampleID != batchItem.NumberOfSamples) && dataType == 'Individual'} <!--Nutritional Info--> 

				<div class="formSubmitBtn" id="Back" on:click={(e)=> changeFormState(e)}>
					Back
				</div>

				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={(e)=> changeFormState(e)}>
						Next
					</div>		
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next" >
						Next
					</div>		
				{/if}
			{:else if (formState == 3 && sampleID == batchItem.NumberOfSamples) && dataType == 'Individual'}
				<div class="formSubmitBtn" id="Back" on:click={(e)=> changeFormState(e)}>
					Back
				</div>
				
				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={()=> submitForm()}>
						Submit
					</div>	
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next">
						Submit
					</div>	
				{/if}
			{:else if (formState == 3) && dataType == 'Mean'}
				<div class="formSubmitBtn" id="Back" on:click={(e)=> changeFormState(e)}>
					Back
				</div>
				
				{#if dataSaved}
					<div class="formSubmitBtnInactive">
						Save
					</div>
					<div class="formSubmitBtn" id="Next" on:click={()=> submitForm()}>
						Submit
					</div>	
				{:else}
					<div class="formSubmitBtn" on:click={()=> saveData()}>
						Save
					</div>
					<div class="formSubmitBtnInactive" id="Next">
						Submit
					</div>	
				{/if}
			{:else}

			{/if}
			
		</div>
		

</div>


<style>


	.meanTableContainer{
		width: 100%;
		height: fit-content;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-0.6925207756232687vh);
		border-radius: 0.3255208333333333vw;
		flex-grow: 1;

	}

	.meanTableContainer:nth-of-type(1){
		width:70%;
		max-height: 450px;
	}

	.scrollableRows{
		width: 100%;
		overflow-y: scroll;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.meanTableContainer:nth-of-type(2){
		width:25%;
	}

	.meanTableRow{
		width: 95%;
		height: 8.8%;
		min-height: 5.2631578947368425vh;
		display: flex;
		flex-direction: row;
		background-color: transparent;
		border-bottom-color: white;
		border-bottom-width:  0.06510416666666667vw;
		border-bottom-style: solid;
	}



	.meanTableRow:nth-child(even){
		background-color: rgba(33, 153, 255, 0.2);
	}


	.meanTableRowItem{
		width: 25%;
		height: 5.2631578947368425vh;
		color: black;
		display: flex;
		align-items: center;
		font-size: 0.8463541666666666vw;
		font-weight: 700;
		/*opacity: 0.8;*/
		flex-grow: 1;
	}
	.meanTableRowItem:nth-child(5){
		justify-content: center;	
	}

	::placeholder{
		color: var(--c, black);
		opacity: 1 !important;
	}

	.tableInputText{
		/*height: 90%;*/
		height: 5.2631578947368425vh;
		background-color: transparent;
		color: black;
		border: none;
		outline: none;
	}

	.tableInputText:focus{
		outline: none;
	}

	
	

	.tableInputSelect{      
		-webkit-appearance: auto;
		-moz-appearance: auto;
		background-color: transparent;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		border: none;
	}



	.tableInputSelectOption{
		width: 100%;
		/*height: 33.333333%;*/
		height: 5.2631578947368425vh;
		background-color: transparent;
		border:  0.06510416666666667vw solid white;
		border-radius: 0px;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;

	}


	.newBatchFormContainer{
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.titleContainer{
		width: 90%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
	}

	.titleItem{
		width:fit-content;
		height: 100%;
		color: black;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 1.0416666666666667vw;
	}

	.titleItemSelected{
		opacity: 1 !important;
	}

	.textOrange{
		color: #FFAE6A !important;
	}

	.formColumnsContainer{
		width: 90%;
		height: 80%;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		gap: 2%;
		/*background-color: orange;*/
	}
	.formColumn{
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		gap: 5%;
		/*background-color: green;*/
	}


	.generalInfo{
		width: 50%;
		align-items: flex-start;
	}

	.generalInfo:nth-child(2){
		align-items: flex-end;
	}

	.dataType{
		width: 50%;
		align-items: flex-start;
		justify-content: flex-start !important;
	}
	
	.formLabel{
		width: 80%;
		height: 2.770083102493075vh;
		background-color: transparent;
		color: black;
		opacity: 0.8;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
	}

	.formInput{
		width: 80%;
		height: 5.54016620498615vh;
		border: 1px solid white;
		border-radius: 3px;
		background-color: transparent;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}



	.formSelect{      
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-appearance: auto;
		-moz-appearance: auto;
		/*background-color: transparent;*/
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
	}

	.formInputOption{
		width: 100%;
		height: 33.333333%;
		background-color: white;
		border: 1px solid white;
		border-radius: 3px;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 700;
	}

	.formSubmitBtnContainer{
		margin-top: 0%;
		width: 100%;
		height: 10%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
		/*background-color: darkred;*/
		transform: translateY(-2%);
	}


	.formSubmitBtn{
		width: 10%;
		height: 5.54016620498615vh;
		border: 1px solid white;
		border-radius: 3px;
		background-color: transparent;
		color: var(--brand-accent);
		font-size: 0.9114583333333334vw;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0.8;
		cursor: pointer;
		margin-left: 2%;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}

	.formSubmitBtn:hover{
		box-shadow: inset -4px -4px 4px rgba(255, 255, 255, 0.2), 
           inset 4px 4px 4px rgba(70, 70, 70, 0.3);
		transform: translateY(0px);

	}

	.formSubmitBtnInactive{
		width: 10%;
		height: 5.54016620498615vh;
		border: 1px solid white;
		border-radius: 3px;
		background-color: transparent;
		color: black;
		font-size: 0.9114583333333334vw;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0.5;
		cursor: pointer;
		margin-left: 2%;
		box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2); 
		transform: translateY(-5px);
	}


</style>